export const ROLE_LABELS = {
  super_admin: 'Super Admin',
  admin: 'Admin',
  employee: 'Employee',
  client: 'Client',
};

// Centralized nav menu per role - keeps Sidebar.js declarative.
// `icon` keys map to lucide-react icon components (see Sidebar.js ICONS map).
export const NAV_BY_ROLE = {
  super_admin: [
    { to: '/dashboard', label: 'Dashboard', icon: 'dashboard' },
    { to: '/clients', label: 'Clients', icon: 'clients' },
    { to: '/employees', label: 'Employees', icon: 'employees' },
    { to: '/projects', label: 'Projects', icon: 'projects' },
    { to: '/tasks', label: 'Tasks', icon: 'tasks' },
    { to: '/documents', label: 'Documents', icon: 'documents' },
    { to: '/document-requests', label: 'Document Requests', icon: 'documentRequests' },
    { to: '/tickets', label: 'Internal Tickets', icon: 'tickets' },
    { to: '/client-tickets', label: 'Client Support', icon: 'clientSupport' },
    { to: '/communication', label: 'Team Chat', icon: 'communication' },
    { to: '/announcements', label: 'Announcements', icon: 'announcements' },
    { to: '/knowledge-base', label: 'Knowledge Base', icon: 'knowledgeBase' },
    { to: '/timesheets', label: 'Timesheets', icon: 'timesheets' },
    { to: '/invoices', label: 'Invoices', icon: 'invoices' },
    { to: '/payments', label: 'Payments', icon: 'payments' },
    { to: '/reports', label: 'Reports', icon: 'reports' },
    { to: '/audit-logs', label: 'Audit Logs', icon: 'auditLogs' },
    { to: '/notifications', label: 'Notifications', icon: 'notifications' },
  ],
  admin: [
    { to: '/dashboard', label: 'Dashboard', icon: 'dashboard' },
    { to: '/clients', label: 'Clients', icon: 'clients' },
    { to: '/employees', label: 'Employees', icon: 'employees' },
    { to: '/projects', label: 'Projects', icon: 'projects' },
    { to: '/tasks', label: 'Tasks', icon: 'tasks' },
    { to: '/documents', label: 'Documents', icon: 'documents' },
    { to: '/document-requests', label: 'Document Requests', icon: 'documentRequests' },
    { to: '/tickets', label: 'Internal Tickets', icon: 'tickets' },
    { to: '/client-tickets', label: 'Client Support', icon: 'clientSupport' },
    { to: '/communication', label: 'Team Chat', icon: 'communication' },
    { to: '/announcements', label: 'Announcements', icon: 'announcements' },
    { to: '/knowledge-base', label: 'Knowledge Base', icon: 'knowledgeBase' },
    { to: '/timesheets', label: 'Timesheets', icon: 'timesheets' },
    { to: '/invoices', label: 'Invoices', icon: 'invoices' },
    { to: '/payments', label: 'Payments', icon: 'payments' },
    { to: '/reports', label: 'Reports', icon: 'reports' },
    { to: '/notifications', label: 'Notifications', icon: 'notifications' },
  ],
  employee: [
    { to: '/dashboard', label: 'Dashboard', icon: 'dashboard' },
    { to: '/clients', label: 'My Clients', icon: 'clients' },
    { to: '/projects', label: 'Projects', icon: 'projects' },
    { to: '/tasks', label: 'My Tasks', icon: 'tasks' },
    { to: '/documents', label: 'Documents', icon: 'documents' },
    { to: '/document-requests', label: 'Document Requests', icon: 'documentRequests' },
    { to: '/tickets', label: 'Internal Tickets', icon: 'tickets' },
    { to: '/client-tickets', label: 'Client Support', icon: 'clientSupport' },
    { to: '/communication', label: 'Team Chat', icon: 'communication' },
    { to: '/announcements', label: 'Announcements', icon: 'announcements' },
    { to: '/knowledge-base', label: 'Knowledge Base', icon: 'knowledgeBase' },
    { to: '/timesheets', label: 'My Timesheet', icon: 'timesheets' },
    { to: '/notifications', label: 'Notifications', icon: 'notifications' },
  ],
  client: [
    { to: '/dashboard', label: 'Dashboard', icon: 'dashboard' },
    { to: '/projects', label: 'My Projects', icon: 'projects' },
    { to: '/documents', label: 'My Documents', icon: 'documents' },
    { to: '/document-requests', label: 'Document Requests', icon: 'documentRequests' },
    { to: '/client-tickets', label: 'Support Tickets', icon: 'clientSupport' },
    { to: '/invoices', label: 'Invoices', icon: 'invoices' },
    { to: '/announcements', label: 'Announcements', icon: 'announcements' },
    { to: '/notifications', label: 'Notifications', icon: 'notifications' },
  ],
};
